// extracted by mini-css-extract-plugin
export var dataCell = "_qh-2";
export var dataRow = "_qh-0";
export var headerRow = "_qh-1";